export default function Description() {
  return (
    <div id="About" name="About" className="shadow bg-gray-100">
      <div className="flex flex-col py-10 md:py-20 text-3xl md:text-4xl outline-1">
        <p className="px-10 leading-tight max-w-5xl mx-auto text-black text-xl md:px-20 md:text-3xl tracking-tight sm:text-2xl">
          <br/>
          <br/>
          <strong>
          Hello, hello. 👋 My name is Abraham, I am a Software Engineer 🧑🏻‍💻 at <a href="https://www.medtronic.com/" className="text-mdtBlue hover:underline" target="_blank">Medtronic</a> and an <a href="https://www.asu.edu" className="text-asuMaroon hover:underline" target="_blank">Arizona State University 🔱</a> Alumni!
          </strong>
          <br/>
          <br/>
         
          After a wonderful internship and upon graduation, 
          I will be returning to Medtronic to begin my journey as a Software Engineer.
          I am a person who is passionate about computer science and 
          I hope to utilize the skills that I learned in school and 
          at work to write code that will benefit society!
          <br/>
          <br/> 
          Please contact me at: <a href="mailto:me@abrahamtrinh.com" class="hover:underline">me@abrahamtrinh.com</a>

          <br/>
          <br/> 
        </p>
      </div>
    </div>
    
  )
}